'use client';
import React, { useState } from 'react';

const faqs = [
  {
    q: 'Is Superpower Resume free?',
    a: 'Yes! The free plan includes 3 resumes and 1 cover letter per month, 5 document uploads, 10 AI chat messages, 1 voice mock interview per month, and basic ATS match scoring — with claim verification included, like every plan. If you need more, Pro ($19/mo, or $16/mo billed annually) gives you 25 resumes/month, 25 documents, 5 voice mock interviews with 3D avatars, LinkedIn optimization, and priority support. Premium ($39/mo, or $33/mo billed annually) gives you up to 100 resumes, 20 voice interviews, 500 AI messages, and the full LinkedIn optimization suite. Executive ($49/mo, or $41/mo billed annually) makes everything unlimited and adds the Executive Suite: Value Profiles, executive-grade documents, role playbooks, and AI role research.'
  },
  {
    q: 'How does this actually work?',
    a: 'Upload your career documents (resumes, LinkedIn exports, etc.) or complete a quick career interview. Our AI indexes your real experience using RAG (Retrieval-Augmented Generation). When you paste a job description, we pull the most relevant parts of your career history and generate a tailored resume and cover letter for that specific role.'
  },
  {
    q: 'What is the ATS Match Score?',
    a: 'Before you generate a resume, our ATS Match Score analyzes the job description against your career profile. It shows your keyword match percentage, highlights which requirements you meet, and flags missing keywords — so you know exactly where you stand before applying.'
  },
  {
    q: 'What makes this better than ChatGPT or resume templates?',
    a: 'ChatGPT doesn\'t know your career history — you have to paste everything every time and hope it doesn\'t make things up. Superpower Resume stores and indexes your real experience, then uses RAG to pull only the relevant details for each job. Every claim is verified against your real history after generation, and the AI cannot invent numbers that aren\'t in your career data. Plus you get ATS scoring, cover letters, and revision chat built in.'
  },
  {
    q: 'Do I need to write anything myself?',
    a: 'Just upload your existing resume or answer a few career interview questions, then paste the job listing. We handle the rest — but you can always refine the output with our AI chat to adjust tone, add details, or rewrite specific sections.'
  },
  {
    q: 'Will you sell or share my data?',
    a: 'Absolutely not. Your data stays private. We don\'t sell, share, or use your information for anything other than generating your documents.'
  },
];

export default function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="space-y-6">
      {faqs.map((faq, idx) => {
        const isOpen = open === idx;
        return (
          <div
            key={faq.q}
            className={`rounded-2xl bg-white overflow-hidden transition-all duration-300 shadow ${isOpen ? 'border-2 border-gradient-to-r from-blue-500 to-blue-300 shadow-xl' : 'border border-gray-100'} `}
            style={{
              boxShadow: isOpen ? '0 8px 32px 0 rgba(37, 99, 235, 0.10)' : undefined,
            }}
          >
            {/* Gradient bar accent for open item */}
            {isOpen && (
              <div className="h-1 w-full bg-gradient-to-r from-blue-600 to-blue-400" />
            )}
            <button
              className={`w-full flex items-center justify-between px-8 py-6 text-left text-lg md:text-xl font-semibold text-black focus:outline-none transition-all duration-200 ${isOpen ? 'bg-blue-50/30' : 'hover:bg-blue-50/40'}`}
              onClick={() => setOpen(isOpen ? null : idx)}
              aria-expanded={isOpen}
            >
              <span>{faq.q}</span>
              <span
                className={`ml-4 flex items-center justify-center w-9 h-9 rounded-full border-2 transition-all duration-300 text-2xl
                  ${isOpen
                    ? 'bg-gradient-to-r from-blue-600 to-blue-400 text-white border-blue-400 shadow-lg rotate-45'
                    : 'border-transparent text-transparent bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-blue-500 hover:text-white hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-400 hover:border-blue-400'}
                `}
                style={!isOpen ? {
                  borderImage: 'linear-gradient(to right, #3b82f6, #60a5fa) 1',
                  color: 'transparent',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                } : {}}
                aria-hidden="true"
              >
                {isOpen ? '−' : '+'}
              </span>
            </button>
            <div
              className={`px-8 transition-all duration-500 ease-in-out overflow-hidden
                ${isOpen ? 'pb-6 max-h-96 opacity-100' : 'pb-0 max-h-0 opacity-0'}`}
              style={{
                transitionProperty: 'max-height, opacity, padding',
              }}
            >
              <div className={`transition-opacity duration-500 ${isOpen ? 'opacity-100' : 'opacity-0'} text-black`}>{isOpen && faq.a}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
} 